import { AuthResponseDTO } from '@arbihunter/api-client';

export interface VerificationCodeSendParamsDto {
  email: string;
}

export interface VerificationCodeSendResponseDto {
  email?: string;
  code?: string;
}

export interface VerificationCodeConfirmParamsDto {
  email: string;
  code: string;
}

export type VerificationCodeConfirmResponseDto = AuthResponseDTO & {
  userId: string;
};

export class AuthVerificationError extends Error {
  constructor(
    message: string,
    public readonly code?: string,
  ) {
    super(message);
    this.name = 'AuthVerificationError';
  }
}

export class ValidationError extends Error {
  constructor(
    message: string,
    public readonly fields: { [name: string]: string[] },
  ) {
    super(message);
    this.name = 'ValidationError';
  }
}
